(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eu-popup"] && !Shopify.designMode) return;
  try {
    
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };


  window.addEventListener('load', function() {
    var popup = document.querySelector('.eu-popup-section');
    var debounced = debounce(function() {
      if (!popup) {
        return;
      }

      if (window.scrollY <= 100) {
        if (!popup.classList.contains('eu-popup-section--visible')) {
          popup.classList.add('eu-popup-section--visible')
        }
      } else if (popup.classList.contains('eu-popup-section--visible')) {
        popup.classList.remove('eu-popup-section--visible')
      }
    }, 150);

    debounced();
    window.addEventListener('scroll', debounced);
  });


  } catch(e) { console.error(e); }
})();
})();
